import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import helpers from '@debbie/common/dist/economy/helpers/index.js';
import { Interval, } from '@debbie/common/dist/economy/payment-plans/index.js';
import { Panel } from '../index.js';
import THEME from '../../theme.js';
import Button from '../Button.js';
import DateInput from '../DateInput.js';
import { Input, Checkbox, ButtonGroup, InputGroup } from '../index.js';
import MoneyInput from '../MoneyInput.js';
import { Section, SectionContentPanel } from '../PanelSection.js';
import { h } from '@debbie/cortex/dist/index.js';
import { selectTenant } from '@debbie/cortex/dist/tenant/selectors.js';
import { useDocumentsByReference } from '@debbie/cortex/dist/documents/index.js';
const parseInteger = (int) => Number(int);
const CustomPlanForm = (props) => {
    const { selectPlan, caseVouchers } = props;
    const lang = useSelector((s) => s.lang);
    const documentsLoader = useDocumentsByReference(props.caseId);
    const documents = h.hasData(documentsLoader) ? documentsLoader.data : null;
    const tenant = useSelector(selectTenant);
    const creditor = props.creditor;
    const [moreSettings, setMoreSettings] = useState(false);
    const [interestFreeEnabled, setInterestFreeEnabled] = useState(false);
    const [interestFreeFrom, setInterestFreeFrom] = useState(null);
    const [interestFreeTo, setInterestFreeTo] = useState(undefined);
    const [upfrontEnabled, setUpfrontEnabled] = useState(false);
    const [amountUpfront, setAmountUpfront] = useState(10000);
    const [amountUpfrontRaw, setAmountUpfrontRaw] = useState(10000);
    const [upfrontDate, setUpfrontDate] = useState(moment());
    const [byAmount, setByAmount] = useState(true);
    const [amount, setAmount] = useState(10000);
    const [amountRaw, setAmountRaw] = useState(10000);
    const [duration, setDuration] = useState(2);
    const [durationRaw, setDurationRaw] = useState('2');
    const [interval, setInterval] = useState(Interval.MONTH);
    const [startDate, setStartDate] = useState(moment()
        .utcOffset(120)
        .add(1, 'month')
        .startOf('month')
        .add(moment().format('HH:mm:ss')));
    const [trigger, setTrigger] = useState(null);
    useEffect(() => {
        const balance = -helpers.overview.balance(props.caseVouchers);
        const _amount = Math.floor(balance / 3 / 10000) * 10000 || 10000;
        setAmountRaw(_amount);
        setAmount(_amount);
        setTrigger(Math.random());
    }, [caseVouchers]);
    useEffect(() => {
        if (caseVouchers && trigger)
            setPlan();
    }, [
        trigger,
        byAmount,
        interval,
        startDate,
        upfrontEnabled,
        amountUpfront,
        upfrontDate,
        amount,
        duration,
        interestFreeEnabled,
        interestFreeEnabled && interestFreeFrom,
        interestFreeEnabled && interestFreeTo,
    ]);
    const getInteretFreeFrom = () => {
        return interestFreeFrom || startDate;
    };
    const getInteretFreeTo = () => {
        if (interestFreeTo === null)
            return null;
        if (interestFreeTo)
            return interestFreeTo;
        const to = getInteretFreeFrom().clone();
        return to.add(1, 'month');
    };
    const setPlan = () => {
        if (!caseVouchers ||
            documents == null ||
            tenant == null ||
            creditor == null) {
            return;
        }
        const config = {
            startDate,
            interval,
            duration: !byAmount ? duration : null,
            amount: byAmount ? amount : null,
            amountUpfront: upfrontEnabled ? amountUpfront : null,
            dateUpfront: upfrontEnabled ? upfrontDate : null,
            interestFree: interestFreeEnabled
                ? {
                    from: getInteretFreeFrom(),
                    to: getInteretFreeTo(),
                }
                : null,
        };
        const configSubmit = {
            ...config,
            startDate: config.startDate.toISOString(),
            dateUpfront: config.dateUpfront?.toISOString() || null,
            interestFree: config.interestFree
                ? {
                    from: config.interestFree.from.toISOString(),
                    to: config.interestFree.to?.toISOString() || null,
                }
                : null,
        };
        try {
            const plan = helpers.paymentPlans.gen(tenant, creditor, JSON.parse(JSON.stringify(helpers.vouchers.postProcessing(caseVouchers, {
                includeIrrecoverableVouchers: false,
                includeDeletedVouchers: false,
                includeExpiredVouchers: false,
            }))), documents, configSubmit);
            selectPlan('CUSTOM', plan, configSubmit);
        }
        catch (error) {
            alert(error);
            console.error(error);
        }
    };
    return (React.createElement("div", null,
        React.createElement(Panel, null,
            React.createElement(Section, { header: lang.paymentPlans.calculationFoundation, description: lang.paymentPlans.calculationFoundationDescription },
                React.createElement(SectionContentPanel, { active: byAmount, onClick: () => setByAmount(true) },
                    React.createElement(Checkbox, { checkboxStyle: {
                            fontSize: '1.3em',
                        }, checkMark: true, checked: byAmount, placeholder: lang.paymentPlans.calculateByAmount, onChange: () => { } }),
                    React.createElement(MoneyInput, { value: amountRaw, placeholder: lang.paymentPlans.amount, onChange: (e) => {
                            setAmountRaw(e);
                        }, onKeyDown: (e) => {
                            if (e.key === 'Enter') {
                                setAmount(amountRaw);
                            }
                        }, onBlur: (e) => {
                            setAmount(amountRaw);
                        }, onFocus: () => {
                            if (!byAmount)
                                setByAmount(true);
                        }, button: amountRaw !== amount
                            ? {
                                value: lang.paymentPlans.save,
                                onClick: () => {
                                    setAmount(amountRaw);
                                },
                            }
                            : undefined })),
                React.createElement(SectionContentPanel, { active: !byAmount, onClick: () => setByAmount(false) },
                    React.createElement(Checkbox, { checkboxStyle: {
                            fontSize: '1.3em',
                        }, checkMark: true, checked: !byAmount, placeholder: lang.paymentPlans.calculateByDuration, onChange: () => { } }),
                    React.createElement(Input, { value: durationRaw, placeholder: lang.paymentPlans.entries, type: "number", onChange: (e) => {
                            setDurationRaw(e.target.value);
                        }, onKeyDown: (e) => {
                            if (e.key === 'Enter') {
                                setDuration(parseInteger(durationRaw));
                            }
                        }, onBlur: (e) => {
                            setDuration(parseInteger(durationRaw));
                        }, onFocus: () => {
                            if (byAmount)
                                setByAmount(false);
                        }, button: parseInteger(durationRaw) !== duration
                            ? {
                                value: lang.paymentPlans.save,
                                onClick: () => {
                                    setDuration(parseInteger(durationRaw));
                                },
                            }
                            : undefined }))),
            React.createElement(Section, { header: lang.paymentPlans.startDate, description: lang.paymentPlans.startDateDescription },
                React.createElement(DateInput, { placeholder: lang.paymentPlans.startDate, value: startDate, onChange: (d) => {
                        setStartDate(d);
                    }, minDate: new Date(), allowNull: false })),
            moreSettings ? (React.createElement(React.Fragment, null,
                React.createElement(Section, { header: lang.paymentPlans.upfrontPayment, description: lang.paymentPlans.upfrontPaymentDescription },
                    React.createElement(InputGroup, null,
                        React.createElement(Checkbox, { checked: upfrontEnabled, onChange: (e) => {
                                setUpfrontEnabled(e.target.checked);
                            } }),
                        React.createElement(MoneyInput, { value: amountUpfrontRaw, disabled: !upfrontEnabled, placeholder: lang.paymentPlans.upfrontPayment, onChange: (e) => {
                                setAmountUpfrontRaw(e);
                            }, onKeyDown: (e) => {
                                if (e.key === 'Enter') {
                                    setAmountUpfront(amountUpfrontRaw);
                                }
                            }, onBlur: (e) => {
                                setAmountUpfront(amountUpfrontRaw);
                            }, button: amountUpfrontRaw !== amountUpfront
                                ? {
                                    value: lang.paymentPlans.save,
                                    onClick: () => {
                                        setAmountUpfront(amountUpfrontRaw);
                                    },
                                }
                                : undefined })),
                    React.createElement(DateInput, { placeholder: lang.paymentPlans.upfrontPaymentDate, value: upfrontDate, onChange: (d) => {
                            setUpfrontDate(d);
                        }, minDate: new Date(), allowNull: true, disabled: !upfrontEnabled })),
                React.createElement(Section, { header: lang.paymentPlans.interval, description: lang.paymentPlans.intervalDescription },
                    React.createElement(ButtonGroup, null,
                        React.createElement(Button, { size: "mini", theme: interval === Interval.QUARTERLY ? undefined : 'secondary', onClick: () => {
                                setInterval(Interval.QUARTERLY);
                            } }, lang.paymentPlans.quarterly),
                        React.createElement(Button, { size: "mini", theme: interval === Interval['TWO-MONTHS']
                                ? undefined
                                : 'secondary', onClick: () => {
                                setInterval(Interval['TWO-MONTHS']);
                            } }, lang.paymentPlans.everyOtherMonth),
                        React.createElement(Button, { size: "mini", theme: interval === Interval.MONTH ? undefined : 'secondary', onClick: () => {
                                setInterval(Interval.MONTH);
                            } }, lang.paymentPlans.monthly),
                        React.createElement(Button, { size: "mini", theme: interval === Interval['TWO-WEEKS'] ? undefined : 'secondary', onClick: () => {
                                setInterval(Interval['TWO-WEEKS']);
                            } }, lang.paymentPlans.everyOtherWeek),
                        React.createElement(Button, { size: "mini", theme: interval === Interval.WEEK ? undefined : 'secondary', onClick: () => {
                                setInterval(Interval.WEEK);
                            } }, lang.paymentPlans.weekly))),
                React.createElement(Section, { header: lang.paymentPlans.interestFree, description: lang.paymentPlans.interestFreeDescription },
                    React.createElement(Checkbox, { checked: interestFreeEnabled, onChange: (e) => {
                            setInterestFreeEnabled(e.target.checked);
                        } }),
                    React.createElement(DateInput, { placeholder: lang.paymentPlans.interestFreeFrom, value: getInteretFreeFrom(), onChange: (d) => {
                            setInterestFreeFrom(d);
                        }, maxDate: interestFreeTo ? interestFreeTo.toDate() : undefined, allowNull: true, disabled: !interestFreeEnabled }),
                    React.createElement(DateInput, { placeholder: lang.paymentPlans.interestFreeTo, value: getInteretFreeTo(), onChange: (d) => {
                            setInterestFreeTo(d);
                        }, minDate: interestFreeFrom ? interestFreeFrom.toDate() : undefined, allowNull: true, disabled: !interestFreeEnabled })))) : (React.createElement("p", { style: {
                    marginBottom: '0px',
                } },
                React.createElement("span", { style: {
                        cursor: 'pointer',
                        textTransform: 'uppercase',
                        color: THEME.COLOR_ACCENT,
                        fontWeight: '900',
                        marginBottom: '0px',
                    }, onClick: () => setMoreSettings(true) }, lang.paymentPlans.moreSettings))))));
};
export default CustomPlanForm;
//# sourceMappingURL=CustomPlanForm.js.map